import {
  POST_ORDER_FAIL,
  POST_ORDER_START,
  POST_ORDER_SUCCESS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_START,
  CANCEL_ORDER_START,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_FAIL,
  UPDATE_ORDER_PARAMS,
  REFETCH_ORDERS,
  UPDATE_ORDER_VIA_SOCKET
} from './actionTypes'

const initialState = {
  loading: false,
  error: '',
  orders: [],
  ordersTotalDocs: 0,
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 1,
    totalDocs: 0,
  },
  orderParams: {
    page: 1,
    limit: 10,
    status: "open",
    type: "limit|market",
    "start-time": undefined
  },
  filters: {
    type: null,
    status: null
  },
  cancelLoading: false,
}

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_ORDER_START:
      return {
        ...state,
        error: '',
        loading: true,
      }
    case GET_ORDERS_START:
      return {
        ...state,
        error: '',
        loading: true,
      }
    case POST_ORDER_SUCCESS:
      return {
        ...state,
        orders: state.orders,
        error: '',
        loading: false,
      }
    case POST_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case GET_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: [...action.payload.docs],
        ordersTotalDocs: action.payload.totalDocs,
        pagination: {
          ...state.pagination,
          totalDocs: action.payload.totalDocs,
          totalPages: action.payload.totalPages,
          page: action.payload.page,
          limit: action.payload.limit,
        },
        filters: {
          ...state.filters,
          type: action.payload.type,
          status: action.payload.status,
        }
      }
    case CANCEL_ORDER_START:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: state.orders.filter(order => order._id !== action.payload),
        error: '',
      }
    case CANCEL_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    // Order parameters
    case UPDATE_ORDER_PARAMS:
      return {
        ...state,
        orderParams: {
          ...state.orderParams,
          ...action.payload
        }
      }
    case REFETCH_ORDERS:
      // This is just a trigger action, no state change needed
      return state
      
    case UPDATE_ORDER_VIA_SOCKET: {
      const updatedOrder = action.payload;
      const orderIndex = state.orders.findIndex(order => order._id === updatedOrder._id);
      
      if (orderIndex === -1) {
        // If order not found, add it to the list if it's not already there
        return {
          ...state,
          orders: [...state.orders, updatedOrder]
        };
      }
      
      // Update the existing order
      const newOrders = [...state.orders];
      newOrders[orderIndex] = {
        ...newOrders[orderIndex],
        ...updatedOrder
      };
      
      return {
        ...state,
        orders: newOrders
      };
    }
      
    default:
      return state
  }
}
export default orderReducer
